import { TpDashboardContext, TpDashboardElement, TpBitmapDefinition } from '../../dashboard/interfaces';
import { TpDataContext } from '../../../../data/interfaces';
import { useAppDispatch } from '../../../../app/hooks';
import { ElementEditTools } from '../../dashboard/edit-mode/ElementEditTools';
import styles from '../../widget/Widget.module.scss';
import docStyles from '../../chart-types-documentation/ChartTypesDocumentation.module.scss';
import docViewerStyles from '../../widget-doc-viewer/WidgetDocViewer.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { showErrorMessage } from '../../../../components/message-boxes/ErrorMessage';
import { getBitmap } from '../../../../data/analyticsDataSlice';
import { useState } from 'react';
import { BlockingOpenedItem } from '../../../../components/blocking-opened-item/BlockingOpenedItem';
import { useExportFilename } from '../../hooks/useExportFilename';
import Markdown from 'react-markdown';

interface TpStaticTextProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpBitmapDefinition;
}

function BitMap({ dataContext, parentElemDef, elemDef, dashboardContext }: TpStaticTextProps) {
  const dispatch = useAppDispatch();
  const { getFilename } = useExportFilename();
  const image = getBitmap(dataContext, elemDef.id);
  const imageDescription = elemDef.description ?? '';

  const [docsActive, setDocsActive] = useState(false);

  const extension = image.fileLocation.split('.').pop();
  const fileName = getFilename(
    {
      assetId: dataContext.assetId,
      dataType: 'bitmap',
      title: image.fileLocation.slice(0, -(extension?.length ? extension.length + 1 : 0)),
    },
    extension || 'png',
  );

  const downloadImagePerFileExtension = () => {
    switch (extension) {
      case 'jpg':
      case 'jpeg':
      case 'png': {
        const link = document.createElement('a');
        link.href = image.content;
        link.download = fileName;
        link.click();
        break;
      }
      default:
        showErrorMessage(`Unsupported file extension: ${extension}`);
    }
  };

  const renderImagePerFileExtension = () => {
    switch (extension) {
      case 'jpg':
      case 'jpeg':
      case 'png':
        return <img src={image.content} className={styles.bitmap} />;
      default:
        return <div>Unsupported file extension: {extension}</div>;
    }
  };

  return (
    <div className={styles.bitmapWrapper} style={{ position: 'relative' }}>
      {renderImagePerFileExtension()}
      <div className={styles.toolBox}>
        {imageDescription != null && (
          <button className={docViewerStyles.title} onClick={() => setDocsActive(true)}>
            <FontAwesomeIcon icon={['fad', 'info-circle']} />
          </button>
        )}
        <button className={styles.toolInactive} onClick={() => downloadImagePerFileExtension()}>
          <FontAwesomeIcon icon="download" />
        </button>
      </div>
      {docsActive && (
        <BlockingOpenedItem
          fraction={80}
          close={() => {
            setDocsActive(false);
          }}
        >
          <div className={docStyles.detailedContainer}>
            <h1>
              <FontAwesomeIcon icon={['fad', 'info-circle']} className={docViewerStyles.title} />
            </h1>
            <Markdown>{imageDescription ?? image.description}</Markdown>
          </div>
        </BlockingOpenedItem>
      )}
      {dashboardContext.editMode && (
        <ElementEditTools
          dataContext={dataContext}
          dashboardContext={dashboardContext}
          parentElemDef={parentElemDef}
          elemDef={elemDef}
          dispatch={dispatch}
        />
      )}
    </div>
  );
}

export default BitMap;
